import Http from "./HttpService";
import { DEFAULT_LIMIT, DEFAULT_OFFSET } from "../constants/pagination";

class TutorService extends Http {
  BASE_URL = "/admins/tutors";

  getList(params) {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET, ...rest } = params;
    return this.get(this.BASE_URL, {
      params: {
        limit,
        offset,
        ...rest,
      },
    });
  }
}

export default new TutorService();

